import React from 'react';
import { connect } from 'react-redux';
import { addToCart } from '../../../redux/shopping/shoppingActions';
const Product = ({ product, addToCart, cart }) => {
  console.log(cart);
  const currentProduct = cart.find((c) => c.id === product.id);

  let isStock = false;

  if (currentProduct) {
    isStock = currentProduct.quantity >= product.totalProduct;
  }

  return (
    <div class="col-span-12 sm:col-span-12 md:col-span-7 lg:col-span-7 xxl:col-span-7">
      <div class="bg-white py-4 px-4 shadow-sm rounded-lg my-4 mx-4">
        <div class="flex justify-between flex-row px-4 items-center">
          <div class="text-lg font-semibold">
            <p>
              {product.title} ({product.stock})
            </p>
            <p class="text-gray-400 text-base">Price {product.price} TK</p>
          </div>
          <div class="text-lg font-semibold">
            <button
              onClick={() => addToCart(product.id)}
              disabled={isStock}
              class="focus:outline-none bg-purple-700 hover:bg-purple-800 text-white font-bold py-2 px-2 rounded-full inline-flex items-center"
            >
              <svg
                xmlns="http://www.w3.org/2000/svg"
                class="h-6 w-6"
                fill="none"
                viewBox="0 0 24 24"
                stroke="currentColor"
              >
                <path
                  stroke-linecap="round"
                  stroke-linejoin="round"
                  stroke-width="2"
                  d="M12 9v3m0 0v3m0-3h3m-3 0H9m12 0a9 9 0 11-18 0 9 9 0 0118 0z"
                />
              </svg>
            </button>
          </div>
        </div>
      </div>

      {/* <div class="bg-white py-4 px-4 shadow-md rounded-lg my-4 mx-4">


        <div class="flex justify-between px-4 items-center">
          <div class="text-lg font-semibold">
            <p>Dell E1916HV 18.5 Inch (35)</p>
            <p class="text-gray-400 text-base">Tk 9,300</p>
          </div>
          <div class="text-lg font-semibold">
            <button class="focus:outline-none bg-purple-700 hover:bg-purple-800 text-white font-bold py-2 px-2 rounded-full inline-flex items-center">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                class="h-6 w-6"
                fill="none"
                viewBox="0 0 24 24"
                stroke="currentColor"
              >
                <path
                  stroke-linecap="round"
                  stroke-linejoin="round"
                  stroke-width="2"
                  d="M12 9v3m0 0v3m0-3h3m-3 0H9m12 0a9 9 0 11-18 0 9 9 0 0118 0z"
                />
              </svg>
            </button>
          </div>
        </div>
      </div> */}

      {/* <div class="bg-white py-4 px-4 shadow-md rounded-lg my-4 mx-4">
        <div class="flex justify-between px-4 items-center">
          <div class="text-lg font-semibold">
            <p>Canon Eos 4000D 18MP (72)</p>
            <p class="text-gray-400 text-base">Tk 36,500</p>
          </div>
          <div class="text-lg font-semibold">
            <button class="focus:outline-none bg-purple-700 hover:bg-purple-800 text-white font-bold py-2 px-2 rounded-full inline-flex items-center">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                class="h-6 w-6"
                fill="none"
                viewBox="0 0 24 24"
                stroke="currentColor"
              >
                <path
                  stroke-linecap="round"
                  stroke-linejoin="round"
                  stroke-width="2"
                  d="M12 9v3m0 0v3m0-3h3m-3 0H9m12 0a9 9 0 11-18 0 9 9 0 0118 0z"
                />
              </svg>
            </button>
          </div>
        </div>
      </div> */}
    </div>
  );
};
const mapDispatchToProps = (dispatch) => {
  return {
    addToCart: (id) => dispatch(addToCart(id)),
  };
};
const mapStateToProps = (state) => {
  return {
    cart: state.shop.cart,
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(Product);
